import axios from "axios";
import config from "../../config";

const baseUrl  = config.baseUrl;
const endpoint = "/api/dashboard";

/**
 * @typedef {Object} DashboardFiltros
 * @property {number}  [municipio_id]  - ID del municipio a filtrar
 * @property {number}  [promotor_id]   - ID del promotor/encuestador a filtrar
 * @property {string}  [fecha_inicio]  - Fecha inicio "YYYY-MM-DD"
 * @property {string}  [fecha_fin]     - Fecha fin   "YYYY-MM-DD"
 */

/**
 * Obtiene todos los indicadores del dashboard en una sola llamada.
 * @param {DashboardFiltros} filtros
 */
export const obtenerResumenDashboard = async (filtros = {}) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/resumen`, {
      params: filtros,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo resumen del dashboard:", error);
    throw error;
  }
};

/**
 * Cantidad de encuestas agrupadas por encuestador.
 * @param {DashboardFiltros} filtros
 */
export const obtenerEncuestasPorEncuestador = async (filtros = {}) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/encuestadores`, {
      params: filtros,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo encuestas por encuestador:", error);
    throw error;
  }
};

/**
 * Encuestas reportadas por día (o por hora si fecha_inicio === fecha_fin).
 * @param {DashboardFiltros} filtros
 */
export const obtenerEncuestasPorDia = async (filtros = {}) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/por-dia`, {
      params: filtros,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo encuestas por día:", error);
    throw error;
  }
};

/**
 * Distribución de encuestados por sexo.
 * @param {DashboardFiltros} filtros
 */
export const obtenerDistribucionSexo = async (filtros = {}) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/sexo`, {
      params: filtros,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo distribución por sexo:", error);
    throw error;
  }
};

/**
 * Total de encuestados y porcentaje con discapacidad.
 * @param {DashboardFiltros} filtros
 */
export const obtenerPorcentajeDiscapacidad = async (filtros = {}) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/discapacidad`, {
      params: filtros,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo porcentaje de discapacidad:", error);
    throw error;
  }
};

/**
 * Cantidad de encuestas por municipio.
 * @param {DashboardFiltros} filtros
 */
export const obtenerEncuestasPorMunicipio = async (filtros = {}) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/municipios`, {
      params: filtros,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo encuestas por municipio:", error);
    throw error;
  }
};
